"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var deeply = function (map) { return function (obj, fn) {
    if (lodash_1.isArray(obj)) {
        return lodash_1.map(obj, function (v) { return (lodash_1.isObject(v) ? deeply(map)(v, fn) : v); });
    }
    else {
        return map(lodash_1.mapValues(obj, function (v) { return (lodash_1.isObject(v) ? deeply(map)(v, fn) : v); }), fn);
    }
}; };
exports.default = deeply;
//# sourceMappingURL=deeply.js.map